import React from 'react';

const Label = (props) => {
    const {continent, creator_count, pos_y, pos_x} = props.label;

    return(
        <div
            className='user-demographic-map-label'
            style={{top: pos_y, left: pos_x}}>
            <span className='label-creator-count'>{creator_count}</span>
            <span className='label-creators'>creators</span>
            <span className='label-continent'>{continent}</span>
        </div>
    );
};

export default Label;



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/label.js